<template>
  <el-dialog
    :title="editForm.id==null||editForm==''?$t('deng-ji-chong-dian-qiang'):$t('bian-ji-chong-dian-qiang')"
    :visible="editFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="editForm.id!=null&&editForm!=''"
    :modal-append-to-body='false'
    :before-close="clearEditForm">
    <el-form :model="editForm" ref="editForm" size="mini" class="edit_form" :rules="editFormRules">
      <el-col :span="12">
        <el-form-item :label="$t('deviceControl.operatorId')" :label-width="formLabelWidth" prop="operatorId">
<!--          <el-select placeholder="运营商" :disabled="showFormFlag =='edit'" v-model="editForm.operatorId" @change="operatorSelect">
            <el-option v-for="item in operatorForSelect" :key="item.id" :disabled="operatorDisable(item)"
                       v-bind:label="item.name" v-bind:value="item.id"></el-option>
          </el-select>-->
          <el-cascader  size="mini" :disabled="showFormFlag =='edit'"
                        :placeholder="$t('deviceControl.operatorId')"  filterable  ref="cascader"
                        :options="this.setTreeDisable(this.operatorForSelect)"
                        :show-all-levels="false"
                        :props="{ checkStrictly:true,expandTrigger:'hover'}"
                        change-on-select
                        @change='handleChangeOperator'
                        v-model="editForm.operatorId">
          </el-cascader>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('suo-shu-chang-zhan')" :label-width="formLabelWidth" prop="stationId">
          <el-select :placeholder="$t('xuan-ze-zhan')" :disabled="showFormFlag =='edit'" v-model="editForm.stationId" @change="stationSelect">
            <el-option v-for="item in stationsForSelect" :key="item.id"
                       v-bind:label="item.stationName" v-bind:value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('suo-shu-she-bei')" :label-width="formLabelWidth" prop="pileId">
          <el-select :placeholder="$t('xuan-ze-zhuang')" :disabled="showFormFlag =='edit'" v-model="editForm.pileId" @change="pileSelect">
            <el-option v-for="item in pilesForSelect" :key="item.id"
                       v-bind:label="item.name" v-bind:value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('qiang-shi-fou-zai-xian')" :label-width="formLabelWidth" prop="gunConnectionState">
          <el-select :placeholder="$t('qiang-shi-fou-zai-xian')"  v-model="editForm.gunConnectionState">
            <el-option v-for="item in gunConnectionStateData" :key="item.value"
                       v-bind:label="item.message" v-bind:value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('deviceControl.GunWorkingStatus')" :label-width="formLabelWidth" prop="state">
          <el-select :placeholder="$t('deviceControl.GunWorkingStatus')"  v-model="editForm.state">
            <el-option v-for="item in gunWorkStateData" :key="item.value"
                       v-bind:label="item.message" v-bind:value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('alaramMonitor.EquipmentNumber')" :label-width="formLabelWidth" prop="pileCode">
          <el-input disabled v-model="editForm.pileCode"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('alaramMonitor.voltage')" :label-width="formLabelWidth" prop="voltage">
          <el-input  v-model="editForm.voltage"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('alaramMonitor.current')" :label-width="formLabelWidth" prop="current">
          <el-input  v-model="editForm.current"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('alaramMonitor.power')" :label-width="formLabelWidth" prop="power">
          <el-input  v-model="editForm.power"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('di-suo-di-zhi')" :label-width="formLabelWidth" prop="lockAddress">
          <el-select
            size="mini"
            remote
            filterable
            clearable
            reserve-keyword
            :placeholder="$t('qing-shu-ru-di-suo-di-zhi-zhi-shao-shu-ru-3-wei')"
            :remote-method="searchLockListByAddress"
            :loading="searchLoading"
            v-model="editForm.lockAddress"
            class="userRole">
            <el-option v-for="item in lockList"
                       :key="item.address"
                       :label="item.address"
                       :value="item.address">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <div v-if="showFormFlag == 'edit'">
        <el-col :span="12">
          <el-form-item :label="$t('deviceControl.pileId')" :label-width="formLabelWidth" prop="pileCode">
            <el-input :placeholder="$t('shu-ru-zhuang-bian-hao')" disabled v-model="editForm.pileCode">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('siteMonitor.gunCode')" :label-width="formLabelWidth" prop="gunCode">
            <el-input :placeholder="$t('shu-ru-qiang-bian-hao')"  v-model="editForm.gunCode">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('qiang-kou-hao')" :label-width="formLabelWidth" prop="gunNum">
            <el-input :placeholder="$t('shu-ru-qiang-kou-hao')" v-model="editForm.gunNum">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('qiang-ming-cheng-0')" :label-width="formLabelWidth" prop="gunName">
            <el-input :placeholder="$t('shu-ru-qiang-ming-cheng')" v-model="editForm.gunName">
            </el-input>
          </el-form-item>
        </el-col>
      </div>
      <div v-else>
        <el-col :span="12">
          <el-form-item :label="$t('lu-ru-fang-shi')" :label-width="formLabelWidth" prop="addMethod">
            <el-select :placeholder="$t('lu-ru-fang-shi-0')" v-model="editForm.addMethod" @change="addMethodChange">
              <el-option :label="$t('pi-liang-xin-zeng')" value="1"></el-option>
              <el-option :label="$t('dan-ge-xin-zeng')" value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <div v-if="editForm.addMethod == '1'">
          <el-col :span="12">
            <el-form-item :label="$t('qi-shi-qiang-bian-hao')" :label-width="formLabelWidth" prop="startGunCode">
              <el-input :placeholder="$t('qi-shi-qiang-bian-hao-0')" disabled="disabled" v-model="editForm.startGunCode">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('jie-shu-qiang-bian-hao')" :label-width="formLabelWidth" prop="endGunCode">
              <el-input :placeholder="$t('jie-shu-qiang-bian-hao-0')" disabled="disabled" v-model="editForm.endGunCode">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('qi-shi-qiang-hao')" :label-width="formLabelWidth" prop="startGunNum">
              <el-input :placeholder="$t('shu-ru-qi-shi-qiang-hao')" v-model="editForm.startGunNum">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('jie-shu-qiang-hao')" :label-width="formLabelWidth" prop="endGunNum">
              <el-input :placeholder="$t('shu-ru-jie-shu-qiang-hao')" v-model="editForm.endGunNum"></el-input>
            </el-form-item>
          </el-col>
        </div>
        <div v-else-if="editForm.addMethod == '2'">
          <el-col :span="12">
            <el-form-item :label="$t('qiang-kou-hao-0')" :label-width="formLabelWidth" prop="gunNum">
              <el-input :placeholder="$t('shu-ru-qiang-kou-hao-0')" v-model="editForm.gunNum">
              </el-input>
            </el-form-item>
          </el-col>
        </div>
        <div v-else></div>
      </div>
      <!--隐藏id-->
      <el-col :span="12" hidden>
        <el-form-item hidden label="id" :label-width="formLabelWidth" prop="id">
          <el-input v-model="editForm.id" autocomplete="off"></el-input>
        </el-form-item>
      </el-col>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="clearEditForm">{{ $t('qu-xiao') }}</el-button>
      <el-button size="small" type="primary" @click.native="editSubmit" :loading="editSubmitLoading">{{ $t('que-ding') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import {validateInput,isIntegerNotMust} from '../../../../common/validator'
  export default {
    name: "add",
    data(){
      return{
        gunConnectionStateData:[
          {value: 0 ,message: this.$t('chargingMonitor.offline')},
          {value: 1 ,message: this.$t('zai-xian')},
        ],
        gunWorkStateData:[
          {value: 0 ,message: "空闲"},
          {value: 1 ,message: "启动充电中"},
          {value: 2 ,message: "充电进行中"},
          {value: 3 ,message: "充电结束"},
          {value: 4 ,message: "启动充电失败"},
          {value: 5 ,message: "预约充电中"},
          {value: 6 ,message: "故障"},
          {value: 7 ,message: "结束充电失败"},
        ],
        searchLoading: false,
        editFormRules: {
          operatorId: [{required: true, message: this.$t('monitoringCenter.opsTreePlaceholder'), trigger: 'blur'}],
          stationId: [{required: true, message: this.$t('qing-xuan-ze-zhan'), trigger: 'blur'}],
          pileId: [{required: true, message: this.$t('qing-shu-xuan-ze-zhuang'), trigger: 'blur'}],
          startGunNum: [{required: true, message: this.$t('qing-shu-ru-qi-shi-qiang-hao'), trigger: 'blur'},{validator:isIntegerNotMust, trigger: 'blur'},{validator:this.startGunNumCheck, trigger: 'blur'}],
          endGunNum: [{required: true, message: this.$t('qing-shu-ru-jie-shu-qiang-hao'), trigger: 'blur'},{validator:isIntegerNotMust, trigger: 'blur'},{validator:this.endGunNumCheck, trigger: 'blur'}],
          //gunNum: [{required: true, message: '请输入枪号', trigger: 'blur'},{validator:isIntegerNotMust, trigger: 'blur'},{max:2, message: '长度不要超过2位', trigger: 'blur'},{validator:this.endGunNumCheck, trigger: 'blur'}],
          gunName: [{required: true, message: this.$t('qing-shu-ru-qiang-ming-cheng'), trigger: 'blur'},{validator: function (rule, value, callback) {
              validateInput(rule, value, callback,0,8,true,true,false,false,false,false,false)
            }, trigger: 'blur'}],
          addMethod: [{required: true, message: this.$t('qing-xuan-ze-lu-ru-fang-shi'), trigger: 'blur'}]
        },
        formLabelWidth: '150px',
      }
    },
    props:{
      editForm:{},
      editFormVisible:false,
      showFormFlag:"",
      operatorForSelect:{},
      stationsForSelect:{},
      pilesForSelect:{},
      editSubmitLoading:false,
      lockList:{
        type:Array,
        default:()=>[]
      },
    },
    methods:{
      async searchLockListByAddress(query) {
        this.$emit("searchLockListByAddress", query)
      },
      operatorDisable(item) {
        // 判断是否为潜在运营商
        const flag = (item.checked && (item.checked === 'unchecked' || item.checked === 'unapproved')) ? true : false
        return flag
      },
      //对数据进行授权过滤
      setTreeDisable(val) {
        //对 treeList 进行递归操作，禁止选中unchecked和unapproved
        val && val.forEach(item => {
          if ((item.checked && (item.checked === 'unchecked' || item.checked === 'unapproved'))) {
            item.disabled = true; // 如果类型为unchecked或者unapproved，就增加禁用选项
          }
          if (item.children) {
            this.setTreeDisable(item.children);
          }
        });
        return val;
      },
      handleChangeOperator(value) {
        let operatorId = value &&value.length >0 ? value[value.length-1] : ''
        this.editForm.operatorId= operatorId
        this.$refs.cascader.dropDownVisible = false
        this.$emit("operatorSelect", operatorId)
      },
      clearEditForm(){
        let _this = this
        if(this.editForm.id == null || this.editForm == '') {
          this.$confirm(this.$t('paramMonitor.message18')).then(_ => {
            _this.$refs.editForm.clearValidate()
            _this.$emit('closeEditForm')
          }).catch(_ => {})
        }else {
          _this.$refs.editForm.clearValidate()
          _this.$emit('closeEditForm')
        }
      },
      editSubmit(){
        this.$emit("editSubmit", this.$refs.editForm)
      },
      operatorSelect(val){
        this.$emit("operatorSelect", val)
      },
      stationSelect(val){
        this.$emit("stationSelect", val)
      },
      pileSelect(){
        this.$emit("pileSelect", this.editForm.pileTypeId)
      },
      startGunNumCheck(rule, value, callback){
        this.$emit("startGunNumCheck", rule, value, callback)
      },
      endGunNumCheck(rule, value, callback){
        this.$emit("endGunNumCheck", rule, value, callback)
      },
      addMethodChange(val){
        if (val == 1){
          this.$set(this.editForm, 'gunNum', "")
        }else if (val == 2){
          this.$set(this.editForm, 'startGunCode', "")
          this.$set(this.editForm, 'endGunCode', "")
          this.$set(this.editForm, 'startGunNum', "")
          this.$set(this.editForm, 'endGunNum', "")
        }
      }
    }
  }
</script>
<style lang="less" scoped>
  /deep/ .edit_form {
      height: auto;
    .el-form-item--mini .el-form-item__content, .el-form-item--mini .el-form-item__label {
      line-height: 25px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/charginggunManager/add.vue